module.exports = __webpack_public_path__ + "img/logo_light.5e5aa8bf.png";